import { render, staticRenderFns } from "./consentComplete.vue?vue&type=template&id=497b2a76&scoped=true"
import script from "./consentComplete.vue?vue&type=script&lang=ts"
export * from "./consentComplete.vue?vue&type=script&lang=ts"
import style0 from "./consentComplete.vue?vue&type=style&index=0&id=497b2a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b2a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VMain,VRow})
